module.exports = __webpack_public_path__ + "assets/img/llsc.cccedc07.png";